export default __webpack_public_path__ + "media/images/icon_keyboard_shortcuts-50957cfd26b5dcaf69010bb7d375336e.png";